import { flatten, map, sort } from "ramda";
import { sortAlpha } from "widgets/utils";

import type { ProjectBasisFragment } from "@/modules/projects/graphql/projects-queries.gql.ts";

import type { Group } from "./types";

export const extractAllProjectsFromGroups = (groups?: Group[] | null): ProjectBasisFragment[] | null => {
  if (!groups) return null;

  const projects = flatten(map((group) => group.accessibleProjects, groups));
  const sortedProjects = sort((a, b) => sortAlpha(a?.name ?? "", b?.name ?? ""), projects);

  return sortedProjects;
};
